import React from "react";
import {
  Card,
  ImageContainer,
  CardImage,
  Content,
  ButtonContainer,
  Button,
} from "./ProductCard.styles";

interface ProductCardProps {
  title: string;
  subtitle: string;
  description: string;
  image: string;
  to: string;
  imageFit?: "cover" | "contain";
  direction?: "row" | "column";
}

const ProductCard: React.FC<ProductCardProps> = ({
  title,
  subtitle,
  description,
  image,
  to,
  imageFit = "cover",
  direction = "column",
}) => {
  return (
    <Card to={to} aria-label={`${title}. ${subtitle}`} $direction={direction}>
      <ImageContainer $direction={direction}>
        <CardImage
          src={image}
          alt=""
          loading="lazy"
          decoding="async"
          $imageFit={imageFit}
          $direction={direction}
        />
      </ImageContainer>

      <Content>
        <h3>{title}</h3>
        <p>{description}</p>
        <ButtonContainer $direction={direction}>
          <Button>Подробнее →</Button>
        </ButtonContainer>
      </Content>
    </Card>
  );
};

export default ProductCard;
